import React from 'react';
import cl from 'classnames';
import { useLanguage } from 'src/hooks';
import { Tooltip } from 'src/components/general';
import styles from './stickyTableStyle.module.scss';

export const CardStatus: React.FC<{
  cardState?: string;
  onlyWarning?: boolean;
  style?: React.CSSProperties;
}> = ({ cardState, onlyWarning, ...restProps }) => {
  const cardIcon = onlyWarning ? (
    <></>
  ) : (
    <svg
      width="19"
      height="24"
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <mask id="path-1-inside-1_4143_10646" fill="white">
        <path d="M2.15333 24C1.54 24 1.028 23.7947 0.617332 23.384C0.205777 22.9724 0 22.46 0 21.8467V7.23067L7.23067 0H16.5133C17.1267 0 17.6387 0.205777 18.0493 0.617332C18.4609 1.028 18.6667 1.54 18.6667 2.15333V21.8467C18.6667 22.46 18.4613 22.972 18.0507 23.3827C17.6391 23.7942 17.1267 24 16.5133 24H2.15333ZM2.15333 22.6667H16.5133C16.7178 22.6667 16.9058 22.5813 17.0773 22.4107C17.248 22.2391 17.3333 22.0511 17.3333 21.8467V2.15333C17.3333 1.94889 17.248 1.76089 17.0773 1.58933C16.9058 1.41867 16.7178 1.33333 16.5133 1.33333H7.8L1.33333 7.8V21.8467C1.33333 22.0511 1.41867 22.2391 1.58933 22.4107C1.76089 22.5813 1.94889 22.6667 2.15333 22.6667ZM2.15333 22.6667H1.33333H17.3333H2.15333Z" />
        <path d="M5.2 10.5C4.70557 10.5 4.42334 11.0645 4.72 11.46L8.5 16.5L13.8197 8.96379C14.1055 8.55887 13.8159 8 13.3203 8C13.1197 8 12.9319 8.09841 12.8177 8.26333L8.5 14.5L5.68 10.74C5.56669 10.5889 5.38885 10.5 5.2 10.5Z" />
      </mask>
      <path
        d="M2.15333 24C1.54 24 1.028 23.7947 0.617332 23.384C0.205777 22.9724 0 22.46 0 21.8467V7.23067L7.23067 0H16.5133C17.1267 0 17.6387 0.205777 18.0493 0.617332C18.4609 1.028 18.6667 1.54 18.6667 2.15333V21.8467C18.6667 22.46 18.4613 22.972 18.0507 23.3827C17.6391 23.7942 17.1267 24 16.5133 24H2.15333ZM2.15333 22.6667H16.5133C16.7178 22.6667 16.9058 22.5813 17.0773 22.4107C17.248 22.2391 17.3333 22.0511 17.3333 21.8467V2.15333C17.3333 1.94889 17.248 1.76089 17.0773 1.58933C16.9058 1.41867 16.7178 1.33333 16.5133 1.33333H7.8L1.33333 7.8V21.8467C1.33333 22.0511 1.41867 22.2391 1.58933 22.4107C1.76089 22.5813 1.94889 22.6667 2.15333 22.6667ZM2.15333 22.6667H1.33333H17.3333H2.15333Z"
        fill="#5B6C7B"
      />
      <path
        d="M5.2 10.5C4.70557 10.5 4.42334 11.0645 4.72 11.46L8.5 16.5L13.8197 8.96379C14.1055 8.55887 13.8159 8 13.3203 8C13.1197 8 12.9319 8.09841 12.8177 8.26333L8.5 14.5L5.68 10.74C5.56669 10.5889 5.38885 10.5 5.2 10.5Z"
        fill="#5B6C7B"
      />
      <path
        d="M0.617332 23.384L244.569 -220.568L0.617332 23.384ZM0 7.23067L-243.952 -236.721L-345 -135.673V7.23067H0ZM7.23067 0V-345H-135.673L-236.721 -243.952L7.23067 0ZM18.0493 0.617332L-226.166 244.305L-225.903 244.569L-225.639 244.833L18.0493 0.617332ZM18.0507 23.3827L262.003 267.335L18.0507 23.3827ZM17.0773 22.4107L260.395 266.995L261.03 266.363L261.662 265.728L17.0773 22.4107ZM17.0773 1.58933L261.662 -241.728L261.03 -242.363L260.395 -242.995L17.0773 1.58933ZM7.8 1.33333V-343.667H-135.104L-236.152 -242.618L7.8 1.33333ZM1.33333 7.8L-242.619 -236.152L-343.667 -135.104V7.8H1.33333ZM1.58933 22.4107L-242.995 265.728L-242.363 266.363L-241.728 266.995L1.58933 22.4107ZM8.5 16.5L-267.5 223.5L16.9541 602.772L290.354 215.456L8.5 16.5ZM8.5 14.5L-267.5 221.5L19.6972 604.43L292.156 210.877L8.5 14.5ZM12.8177 8.26333L-270.839 -188.114L12.8177 8.26333ZM5.68 10.74L281.68 -196.26L5.68 10.74ZM4.72 11.46L-271.28 218.46L4.72 11.46ZM2.15333 -321C40.9249 -321 84.8209 -314.372 129.726 -296.364C175.005 -278.205 213.582 -251.555 244.569 -220.568L-243.335 267.336C-174.301 336.37 -84.2583 369 2.15333 369V-321ZM244.569 -220.568C275.482 -189.655 302.129 -151.137 320.306 -105.869C338.34 -60.9605 345 -17.0208 345 21.8467H-345C-345 108.487 -312.216 198.455 -243.335 267.336L244.569 -220.568ZM345 21.8467V7.23067H-345V21.8467H345ZM243.952 251.183L251.183 243.952L-236.721 -243.952L-243.952 -236.721L243.952 251.183ZM7.23067 345H16.5133V-345H7.23067V345ZM16.5133 345C-22.3494 345 -66.33 338.341 -111.299 320.268C-156.636 302.046 -195.214 275.324 -226.166 244.305L262.265 -243.071C193.284 -312.2 103.16 -345 16.5133 -345V345ZM-225.639 244.833C-256.658 213.881 -283.38 175.302 -301.601 129.966C-319.674 84.9966 -326.333 41.016 -326.333 2.15333H363.667C363.667 -84.4927 330.867 -174.617 261.737 -243.598L-225.639 244.833ZM-326.333 2.15333V21.8467H363.667V2.15333H-326.333ZM-326.333 21.8467C-326.333 -16.9249 -319.706 -60.8209 -301.697 -105.726C-283.538 -151.005 -256.888 -189.582 -225.901 -220.569L262.003 267.335C331.036 198.301 363.667 108.258 363.667 21.8467H-326.333ZM-225.901 -220.569C-194.988 -251.482 -156.47 -278.129 -111.203 -296.306C-66.2939 -314.34 -22.3541 -321 16.5133 -321V369C103.154 369 193.121 336.216 262.003 267.335L-225.901 -220.569ZM16.5133 -321H2.15333V369H16.5133V-321ZM2.15333 367.667H16.5133V-322.333H2.15333V367.667ZM16.5133 367.667C124.443 367.667 208.327 318.793 260.395 266.995L-226.24 -222.174C-174.516 -273.63 -91.0075 -322.333 16.5133 -322.333V367.667ZM261.662 265.728C313.46 213.661 362.333 129.776 362.333 21.8467H-327.667C-327.667 -85.6742 -278.964 -169.182 -227.507 -220.907L261.662 265.728ZM362.333 21.8467V2.15333H-327.667V21.8467H362.333ZM362.333 2.15333C362.333 -105.776 313.46 -189.66 261.662 -241.728L-227.507 244.907C-278.964 193.182 -327.667 109.673 -327.667 2.15333H362.333ZM260.395 -242.995C208.327 -294.793 124.443 -343.667 16.5133 -343.667V346.333C-91.0075 346.333 -174.516 297.63 -226.24 246.174L260.395 -242.995ZM16.5133 -343.667H7.8V346.333H16.5133V-343.667ZM-236.152 -242.618L-242.619 -236.152L245.285 251.752L251.752 245.285L-236.152 -242.618ZM-343.667 7.8V21.8467H346.333V7.8H-343.667ZM-343.667 21.8467C-343.667 129.776 -294.793 213.661 -242.995 265.728L246.174 -220.907C297.63 -169.182 346.333 -85.6742 346.333 21.8467H-343.667ZM-241.728 266.995C-189.661 318.793 -105.776 367.667 2.15333 367.667V-322.333C109.674 -322.333 193.182 -273.63 244.907 -222.174L-241.728 266.995ZM2.15333 -322.333H1.33333V367.667H2.15333V-322.333ZM1.33333 367.667H17.3333V-322.333H1.33333V367.667ZM17.3333 -322.333H2.15333V367.667H17.3333V-322.333ZM-271.28 218.46L-267.5 223.5L284.5 -190.5L280.72 -195.54L-271.28 218.46ZM290.354 215.456L295.674 207.919L-268.034 -189.992L-273.354 -182.456L290.354 215.456ZM-270.839 -188.114L-275.156 -181.877L292.156 210.877L296.474 204.641L-270.839 -188.114ZM284.5 -192.5L281.68 -196.26L-270.32 217.74L-267.5 221.5L284.5 -192.5ZM13.3203 -337C-100.09 -337 -206.284 -281.359 -270.839 -188.114L296.474 204.641C232.148 297.556 126.33 353 13.3203 353V-337ZM295.674 207.919C457.277 -21.018 293.549 -337 13.3203 -337V353C-265.917 353 -429.066 38.1358 -268.034 -189.992L295.674 207.919ZM281.68 -196.26C216.412 -283.284 113.98 -334.5 5.2 -334.5V355.5C-103.203 355.5 -205.279 304.462 -270.32 217.74L281.68 -196.26ZM280.72 -195.54C451.001 31.5009 289.001 355.5 5.2 355.5V-334.5C-279.59 -334.5 -442.154 -9.37197 -271.28 218.46L280.72 -195.54Z"
        fill="#5B6C7B"
        mask="url(#path-1-inside-1_4143_10646)"
      />
    </svg>
  );
  return cardState !== 'ok' ? (
    <svg
      width="19"
      height="24"
      viewBox="0 0 19 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M2.15333 24C1.54 24 1.028 23.7947 0.617332 23.384C0.205777 22.9724 0 22.46 0 21.8467V7.23067L7.23067 0H16.5133C17.1267 0 17.6387 0.205778 18.0493 0.617333C18.4609 1.028 18.6667 1.54 18.6667 2.15333V21.8467C18.6667 22.46 18.4613 22.972 18.0507 23.3827C17.6391 23.7942 17.1267 24 16.5133 24H2.15333ZM2.15333 22.6667H16.5133C16.7178 22.6667 16.9058 22.5813 17.0773 22.4107C17.248 22.2391 17.3333 22.0511 17.3333 21.8467V2.15333C17.3333 1.94889 17.248 1.76089 17.0773 1.58933C16.9058 1.41867 16.7178 1.33333 16.5133 1.33333H7.8L1.33333 7.8V21.8467C1.33333 22.0511 1.41867 22.2391 1.58933 22.4107C1.76089 22.5813 1.94889 22.6667 2.15333 22.6667ZM2.15333 22.6667H1.33333H17.3333H2.15333Z"
        fill="#F84544"
      />
      <path d="M9 16H11V18H9V16ZM9 9H11V14H9V9Z" fill="#F84544" />
    </svg>
  ) : (
    cardIcon
  );
};

export const BatteryStatus: React.FC<{
  battery: number;
  charging: boolean;
  className?: string;
}> = ({ battery, charging, className }) => {
  const { t } = useLanguage();

  if (charging) {
    return (
      <Tooltip
        text={`${battery || 0}%`}
        tooltipClassName={styles.tooltip}
        arrowClassName={styles.tooltipArrow}
      >
        <div className={cl(styles.tag, styles.blue, className)}>
          {t('general.batteryCharging')}
        </div>
      </Tooltip>
    );
  }

  if (battery === null || battery === undefined) {
    return <span>-</span>;
  }

  return battery <= 15 ? (
    <Tooltip
      text={`${battery || 0}%`}
      tooltipClassName={styles.tooltip}
      arrowClassName={styles.tooltipArrow}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke="#F84544"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 16H12.01"
          stroke="#F84544"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 8V12"
          stroke="#F84544"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Tooltip>
  ) : (
    <span>{battery} %</span>
  );
};
